import { render, staticRenderFns } from "./AddApplyEdit.vue?vue&type=template&id=70f82f3a&scoped=true&"
import script from "./AddApplyEdit.vue?vue&type=script&lang=js&"
export * from "./AddApplyEdit.vue?vue&type=script&lang=js&"
import style0 from "./AddApplyEdit.vue?vue&type=style&index=0&id=70f82f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f82f3a",
  null
  
)

export default component.exports